module.exports = __webpack_public_path__ + "07_hige_black.34cba1c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer3/07_hige_black.png
// module id = TfJW
// module chunks = 0